import * as React from 'react';
export const akaneoSvg = React.forwardRef(function akaneoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.84 4A3.84 3.84 0 0 0 4 7.84v16.32A3.84 3.84 0 0 0 7.84 28h16.32A3.84 3.84 0 0 0 28 24.16V7.84A3.84 3.84 0 0 0 24.16 4H7.84Zm12.544 19.723v.002l.001-.001-.001-.001Zm0 0c-.051-.323-.06-.954-.002-1.852.037-.553.183-1.093.358-1.619.288-.86.72-1.657 1.15-2.453l.089-.165.065-.12c.43-.796.897-1.656 1.014-2.558.162-1.247-.706-2.482-1.452-3.398-1.022-1.256-2.272-2.331-3.577-3.283.122 1.19.181 2.444.095 3.66-.082 1.148-.336 2.274-.7 3.365-.2.602-.432 1.193-.696 1.77-.083.183-.09.187-.29.169a18.304 18.304 0 0 1-1.43-.193c-1.138-.2-2.27-.503-3.328-.974-1.248-.553-2.42-1.285-3.52-2.09.129 1.22.352 2.437.695 3.614.316 1.08.724 2.18 1.41 3.083.342.452.774.854 1.317 1.044.485.17 1.009.24 1.518.287a23.67 23.67 0 0 0 1.523.075c.58.017 1.159.033 1.735.098a8.468 8.468 0 0 1 4.026 1.54Z',
      fill: '#994AFF',
    }),
  );
});
akaneoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var akaneo = {
  category: 'brand',
  colorable: false,
  name: 'akaneo',
  svg: akaneoSvg,
};
